import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-dropdown-new-design',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './dropdown-new-design.component.html',
    styleUrls: ['./dropdown-new-design.scss'],
    standalone: false
})
export class DropdownNewDesignComponent implements OnInit {
  @Input() floatingLabel: string = 'Elige una opción';
  @Input() alignEnd: boolean = false;
  @Input() options: any[] = [];
  @Input() selectedValue: string = '';
  @Input() tipoDropdown: 'account' | 'period' = 'account';
  @Output() selectedValueChange = new EventEmitter();

  classesForPopover: string = 'custom-popover';
  classItem: string = 'select-container';
  
  constructor() { }

  async ngOnInit(): Promise<void> {
    if (this.alignEnd) {
      this.classesForPopover += ' align-end';
    }
  }

  onSelectChange(event: any) {
    this.selectedValueChange.emit(event.target.value);

    //evolucion saldos aca logica para evento cuenta o periodo
   
  }
}
